import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Blog.css';

function Blog() {
  return (
    <div>
      <Header />

      {/* ── Page header ── */}
      <section className="blog-hero">
        <h1 className="blog-hero__heading">Blog</h1>
        <p className="blog-hero__sub">
          Stories, updates, and insights from Acriolis India Motors.
        </p>
      </section>

      {/* ── Posts ── */}
      <section className="blog-posts">
        <div className="blog-posts__empty">
          <span className="blog-posts__empty-icon">✦</span>
          <h2 className="blog-posts__empty-title">New stories are on the way</h2>
          <p className="blog-posts__empty-text">
            We're working on articles about off-road adventures, engineering deep-dives,
            and company news. Check back soon!
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Blog;
